

interface CalcTextSizeResult {
  fontSize: number,
  letterSpacing: number,
  offsetX: number,
  actualBoundingBoxAscent: number,
}

function calcTextSize(
  text: string,
  font: string,
  minFontSize: number,
  maxFontSize: number,
  letterSpacingFactor: number,
  widthToMatch: number,
): CalcTextSizeResult {
  var bestLetterSpacing = 0
  var bestOffsetX = 0 

  // Create an offscreen canvas
  const offCanvas = document.createElement("canvas");
  const offCtx = offCanvas.getContext("2d");

  if (!offCtx) {
    throw new Error("Could not get 2D context");
  }
      
  offCanvas.width = widthToMatch;
  offCanvas.height = maxFontSize;

  // Figure out a good font size
  var fontSize = (minFontSize + maxFontSize) / 2
  var sizeIncrement = (maxFontSize - minFontSize) / 4
  var bestRemaining = widthToMatch
  var bestFontSize = fontSize
  var actualBoundingBoxAscent = fontSize
  while (sizeIncrement >= 1.0) {
    offCtx.font = `${Math.round(fontSize)}px ${font}`;
    const letterSpacing = Math.round(fontSize * letterSpacingFactor);
    offCtx.letterSpacing = `${letterSpacing}px`;
    const textMetrics = offCtx.measureText(text);
    const remainingWidth = widthToMatch - (textMetrics.actualBoundingBoxRight + textMetrics.actualBoundingBoxLeft)
    const offsetX = Math.round(textMetrics.actualBoundingBoxLeft + Math.min(remainingWidth, 0) / 2)
    if (Math.abs(remainingWidth) < Math.abs(bestRemaining)) {
      bestRemaining = remainingWidth;
      bestFontSize = Math.round(fontSize);
      bestLetterSpacing = letterSpacing;
      bestOffsetX = Math.round(offsetX);
      actualBoundingBoxAscent = textMetrics.actualBoundingBoxAscent;
    }
    if (remainingWidth <= 0) {
      fontSize -= sizeIncrement;
    } else {
      fontSize += sizeIncrement;
    }
    sizeIncrement = sizeIncrement / 2;
  }

  return { fontSize: bestFontSize, letterSpacing: bestLetterSpacing, offsetX: bestOffsetX, actualBoundingBoxAscent }
}

export { calcTextSize };
export type { CalcTextSizeResult };
